const IndiaCyberLaw = () => {
  return (
    <div className='india-cyber-law'>
      <h2>India's Primary Cyber Law</h2>
      <p>
        India's primary cyber law is the <strong>Information Technology (IT) Act, 2000</strong>, which was amended in
        2008. This law covers a wide range of activities related to the internet, digital communications, and electronic
        commerce. It addresses legal issues concerning online interactions and the internet. The IT Act provides a legal
        framework to manage cyber activities and deals with issues like digital signatures, cybercrime, and electronic
        governance. Some key provisions of the IT Act include:
      </p>
      <ul>
        <li><strong>Cybercrimes:</strong> The IT Act specifies various cybercrimes and penalties associated with them.
          These include hacking, identity theft, phishing, spreading viruses, and unauthorized access to computer
          systems.</li>
        <li><strong>Electronic Governance:</strong> The Act allows for the legal recognition of electronic records and
          digital signatures, facilitating e-governance and e-commerce.</li>
        <li><strong>Regulation of Certifying Authorities:</strong> The Act regulates entities that issue digital
          certificates used to authenticate the identity of individuals and organizations online.</li>
        <li><strong>Data Protection and Privacy:</strong> The IT Act includes provisions for protecting sensitive
          personal data. The 2008 amendments introduced Section 43A, which holds corporations responsible for
          implementing reasonable security practices to protect sensitive personal data they possess or handle.</li>
        <li><strong>Obscenity and Child Pornography:</strong> The Act contains provisions against publishing or
          transmitting obscene material, including child pornography, in electronic form.</li>
        <li><strong>Intermediary Liability:</strong> It outlines the due diligence requirements and liabilities of
          intermediaries, such as internet service providers (ISPs) and social media platforms, regarding unlawful
          content on their networks.</li>
        <li><strong>IT (Amendment) Act, 2008:</strong> This amendment introduced several changes, including enhanced
          penalties for cybercrimes, measures for privacy protection, and provisions for the establishment of a
          Computer Emergency Response Team (CERT-IN) to respond to cybersecurity incidents.</li>
      </ul>
      <p>
        It's important to note that the IT Act is subject to amendments and changes. For the most current information,
        referring to the official Gazette of India or consulting legal professionals who specialize in cyber law in
        India is advisable.
      </p>
    </div>
  );
};

export default IndiaCyberLaw;